import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { IIntervallo } from 'app/model/ambulatorio';
import { Impostazioni } from 'app/model/impostazioni_agenda';
import { Subscription } from "rxjs";
import { RESTObject } from '../../angular-rest';
import { Config } from "../../config.const";

@Component({
	selector: 'app-generali',
	templateUrl: './generali.html',
	styleUrls: ['./../impostazioni_agenda.css']
})

export class OrarioComponent implements OnInit{
	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

  specializzazioni: any[];
  teleconsultiSub: Subscription;
	@Input() impostazioni: RESTObject<Impostazioni> = null;
	correct = true;

	constructor(private $http: HttpClient) { }

	loadSpecializzazioni() {
    this.teleconsultiSub = this.$http.get(`${Config.baseURL}/teleconsulto/specializzazioni`).subscribe((response: any) => {
      this.specializzazioni = response;
    })
  }

	aggiorna(impo: Impostazioni) {
		const interval: IIntervallo = { inizio: impo.inizio_giornata, fine: impo.fine_giornata };
		this.correct = this.check(interval);
		if (this.correct) {
			this.impostazioni.update({ ...impo });
		}
	}

	check(intervallo: IIntervallo) {
		return (intervallo.inizio.hour < intervallo.fine.hour) ||
			(
				(intervallo.inizio.hour === intervallo.fine.hour) &&
				(intervallo.inizio.minute < intervallo.fine.minute)
			);
	}

  ngOnInit(): void {
	  this.loadSpecializzazioni();
  }
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/generali/generali.ts